// componente per la visualizzazione della pagina di inserimento/modifica di un pannello (componente sinistra)
// nella pagina "Pannelli"

import { Component, OnInit, ViewChild, AfterViewChecked } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/service/alert.service';

import { ApiService } from '../../../../service/api.service';
import { AuthenticationService } from '../../../../service/authentication.service';
import { UtilsService } from '../../../../service/helper/utils.service';

import { Availables } from '../availables.model';
import { AvailablesService } from '../availables.service';
import { AvailablesListComponent } from '../availables-list/availables-list.component';
import { AvailablesComponent } from '../availables.component';

@Component({
  selector: 'app-availables-edit',
  templateUrl: './availables-edit.component.html',
  styleUrls: ['./style.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class AvailablesEditComponent implements OnInit, AfterViewChecked {
  private subscription: Subscription;
  @ViewChild('f', { static: true }) availablesForm: NgForm;

  // inizializzazione array e campi utilizzati nella gestione pannelli
  editMode = false; // variabile posta a true se è attiva la modifica di un pannello
  oldId = 0; // ID del pannello prima della modifica
  editAvailablesId = 0; // ID del pannello da modificare
  availables: Availables; // pannello selezionato
  comment = ''; // commento pannello preimpostato come stringa vuota
  profiled: string // profilo utente
  profiles = []
  cards = []
  bodyid: string // id ente
  bodies
  emailAlredyExist = "";

  constructor(private als: AlertService, private authenticationService: AuthenticationService, private availablesComponent: AvailablesComponent, private availablesService: AvailablesService, private availablesList: AvailablesListComponent, private auth: AuthenticationService,
    public dialog: MatDialog,
    public dataStorageService: ApiService, private utilsService: UtilsService) { }

  // da inserire per abilitare l'aggiornamento dei form
  ngAfterViewChecked() {
  }
  emailCheckUnique() {
    if (this.cards.includes(this.availablesForm.value.card)) {
      this.emailAlredyExist = "Tessera già esistente";
    }
    else {
      this.emailAlredyExist = "";
    }
  }

  // metodo richiamato all'inizio quando si entra nella pagina
  ngOnInit() {
    var user = this.authenticationService.user;
    this.dataStorageService.getBodyList().subscribe(v => {
      this.bodies = v
    })
    this.profiled = user.profile
    this.dataStorageService.getAvailablesTot().subscribe(p => {
      p.forEach(v => {
        this.cards.push(v.card)
      })
    })
    if (user.profile == "SuperAdmin") {
      this.profiles = ["Admin", "User", "SuperAdmin"]
    } else if (user.profile == "Admin") {
      this.profiles = ["Admin", "User"]
    }
    var me = this
    if (me.availablesService.available) {
      setTimeout(() => {
        me.availables = me.availablesService.available
        me.profiled == 'SuperAdmin' ? me.availablesForm.setValue({
          firstname: me.availables.firstname ? me.availables.firstname : "",
          lastname: me.availables.lastname ? me.availables.lastname : "",
          password: "",
          card: me.availables.card ? me.availables.card : "",
          email: me.availables.email ? me.availables.email : "",
          telephone: me.availables.telephone ? me.availables.telephone : "",
          profile: me.availables.profile ? me.availables.profile : "",
          enabled: me.availables.enabled ? true : false,
          bodyid: me.availables.bodyid ? me.availables.bodyid : "",
          tag: me.availables.tag ? me.availables.tag : "",
        }) : me.availablesForm.setValue({
          firstname: me.availables.firstname ? me.availables.firstname : "",
          lastname: me.availables.lastname ? me.availables.lastname : "",
          password: "",
          card: me.availables.card ? me.availables.card : "",
          email: me.availables.email ? me.availables.email : "",
          telephone: me.availables.telephone ? me.availables.telephone : "",
          profile: me.availables.profile ? me.availables.profile : "",
          enabled: me.availables.enabled ? true : false,
          tag: me.availables.tag ? me.availables.tag : "",
        }) 
        me.editAvailablesId = me.availablesService.availablesId;
        me.editMode = true;
      }, 100)

    }
  //   setTimeout(() => {

  //   // in base al profilo loggato si definiscono le categorie selezionabili dall'utente
  //   this.profiled = this.auth.currentUserValue.profile
  //   this.bodyid = this.auth.currentUserValue.bodyid
  //   var body
  //   me.profiled == 'SuperAdmin' ? body = (me.availables.bodyid ? me.availables.bodyid : "") : body = undefined
  //   // si riempie la form coi valori preimpostati
  //   this.subscription = this.availablesService.availablesEditMode.subscribe(
  //     (id: number) => {
  //       me.availables = me.availablesService.getAvailablesByIndex(id);
  //       me.oldId = me.availables.id
  //       setTimeout(() => {

  //         me.editMode ? me.availablesForm.setValue({
  //           firstname: me.availables.firstname ? me.availables.firstname : "",
  //           lastname: me.availables.lastname ? me.availables.lastname : "",
  //           password: me.availables.password,
  //           card: me.availables.card ? me.availables.card : "",
  //           email: me.availables.email ? me.availables.email : "",
  //           telephone: me.availables.telephone ? me.availables.telephone : "",
  //           profile: me.availables.profile ? me.availables.profile : "",
  //           enabled: me.availables.enabled ? true : false,
  //           bodyid: body,
  //           tag: me.availables.tag ? me.availables.tag : "",
  //         }):me.availablesForm.setValue({
  //           firstname: me.availables.firstname ? me.availables.firstname : "",
  //           lastname: me.availables.lastname ? me.availables.lastname : "",
  //           password: me.availables.password ? me.availables.password : "",
  //           card: me.availables.card ? me.availables.card : "",
  //           email: me.availables.email ? me.availables.email : "",
  //           telephone: me.availables.telephone ? me.availables.telephone : "",
  //           profile: me.availables.profile ? me.availables.profile : "",
  //           enabled: me.availables.enabled ? me.availables.enabled : "",
  //           bodyid: body,
  //           tag: me.availables.tag ? me.availables.tag : "",
  //         });
        
  //     }, 100)

  //       me.editAvailablesId = id;
  //       me.editMode = true;
        
  //     }
  //   );
  // }, 300)

  }

  parseStringDate(date) {
    var temp = date.split("/");
    return new Date(temp[2], temp[1] - 1, temp[0])

  }

  // metodo richiamato al submit del form (per inserimento o modifica)
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    var body
    me.profiled == 'SuperAdmin' ? body = value.bodyid : body = undefined
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // se non si è in modalità modifica si richiamano tutti i servizi di aggiunta nuovo pannello...
    if (!me.editMode) {

      // l'opportuno servizio restituisce l'ID da inserire per il nuovo pannello (incrementando di 1 il massimo già esistente)
      this.dataStorageService.getMaxAvailables().subscribe(v => {

        // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
        var mess = new Availables(v,
          value.firstname,
          value.lastname,
          value.password,
          value.card,
          value.email,
          value.telephone,
          // "",
          value.profile,
          value.enabled,
          body,
          value.tag
        );

        // si richiama il servizio di back-end per l'inserimento del pannello
        me.dataStorageService.storeAvailables(mess)

        // si richiamano i servizi di aggiornamento tabella
        me.availables = mess;
        me.availablesService.addAvailables(mess);

        // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
        setTimeout(function () {
          me.dataStorageService.getAvailables();
          me.utilsService.hideLoader();
          me.change()
        }, 1000)
      })

      // se si è in modalità modifica si richiamano tutti i servizi di modifica pannello...
    } else {

      // si crea il pannello coi valori digitati dall'utente e l'ID non cambiato
      var new_availables = new Availables(me.editAvailablesId,
        value.firstname,
        value.lastname,
        "",
        value.card,
        value.email,
        value.telephone,
        // "",
        value.profile,
        value.enabled,
        body,
        value.tag
      );

      // si richiamano i servizi di aggiornamento tabella
      me.availables = new_availables;
      me.availables.id = me.editAvailablesId;
      var res = this.availablesList.getIndex(this.availables.id)
      me.availablesService.updateAvailables(res, me.availables);

      // si richiama il servizio di back-end per l'inserimento del pannello
      me.dataStorageService.updateAvailables(me.availables)

      // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
      setTimeout(function () {
        me.dataStorageService.getAvailables();
        me.utilsService.hideLoader();
        me.change()
      }, 1000)
    }
  }
  setDate(date) {
    date = new Date(parseInt(date))
    return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
  }
  // metodo che ripulisce la form di inserimento messaggio
  onClear() {
    var me = this
    if (!this.editMode) {
      me.profiled == 'SuperAdmin' ? me.availablesForm.setValue({
        firstname: '',
        lastname: '',
        password: '',
        card: '',
        email: '',
        telephone: '',
        profile: '',
        enabled: '',
        bodyid: '',
        tag: ''
      }) : me.availablesForm.setValue({
        firstname: '',
        lastname: '',
        password: '',
        card: '',
        email: '',
        telephone: '',
        profile: '',
        enabled: '',
        tag: ''
      })
    } else {
      me.profiled == 'SuperAdmin' ? me.availablesForm.setValue({
        firstname: '',
        lastname: '',
        password: '',
        card: '',
        email: '',
        telephone: '',
        profile: '',
        enabled: '',
        bodyid: '',
        tag: ''
      }) : me.availablesForm.setValue({
        firstname: '',
        lastname: '',
        password: '',
        card: '',
        email: '',
        telephone: '',
        profile: '',
        enabled: '',
        tag: ''
      })
    }
    this.editMode = false;
  }
  isEdit() {
    return this.availablesComponent.isedit
  }
  change() {
    this.utilsService.showLoader(); // viene mostrata l'animazione di caricamento
    this.availablesService.available = undefined
    // this.onClear();
    this.availablesComponent.isedit = !this.availablesComponent.isedit
    this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento

  }
  // metodo richiamato alla cancellazione di un pannello
  onDelete() {
    var me = this

    const conf = this.als.confirm('Sei sicuro di voler eliminare il reperibile?').subscribe(x => {
      if (x === true) {
        me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

        // ... viene cancellato il messaggio dal backend...
        me.dataStorageService.deleteAvailables(me.availables.id)
  
        // ...il messaggio viene eliminato dalla tabella...
        me.availablesService.deleteAvailables(me.availables.id);
  
        // ...viene ripulito la form...
        // me.onClear();
        me.editMode = false;
  
        // dopo 1 secondo scompare l'animazione di caricamento
        setTimeout(function () {
          me.change()
          me.utilsService.hideLoader();
        }, 1000)
      }
      conf.unsubscribe();

    });

  }

  // richiamato per ripulire la form di inserimento
  onAbort() {
    this.onClear();
  }
  import() {
    var me = this
    const dialogRef = this.dialog.open(Upload3, {});
    dialogRef.afterClosed().subscribe(result => {
      me.dataStorageService.getAvailables();
      me.change()
      me.utilsService.hideLoader();
    });

  }
}

@Component({
  selector: 'upload',
  templateUrl: 'file-upload.component.html',
  styleUrls: ['./style.scss']
})
export class Upload3 implements OnInit {

  constructor(public dialogRef: MatDialogRef<Upload3>, public dataStorageService: ApiService, private utilsService: UtilsService) { }
  fileToUpload: File = null;
  jsontosave
  loaded
  ngOnInit() {

  }
  handleFileInput(files: FileList) {
    var me = this
    if (files && files.length > 0) {
      let file: File = files.item(0);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        let csv: string = reader.result as string;
        me.jsontosave = me.csvJSON(csv)
        me.loaded = true
      }
    }
  }
  uploadFileToActivity() {
    var me = this
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
      if (this.readyState == 4 && (this.status == 200 || this.status == 500)) {
        me.dialogRef.close();
      }
    };
    xmlHttp.open("POST", 'https://sosimperium.multiutilitydelgarda.eu:8001/csvavailables', false); // false for synchronous request
    xmlHttp.setRequestHeader("Content-type", "application/json");
    xmlHttp.send(this.jsontosave);
    me.loaded = false
    // this.dataStorageService.storeCsvAvailables(this.jsontosave)
  }

  csvJSON(csv) {
    var lines = csv.split("\n");
    var result = [];
    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length; i++) {

      var obj = {};
      var currentline = lines[i].split(",");

      for (var j = 0; j < headers.length; j++) {
        if (headers[j] && currentline[j]) {
          headers[j] = headers[j].replace(/[\n\r]+/g, '');
          currentline[j] = currentline[j].replace(/[\n\r]+/g, '');
          obj[headers[j]] = currentline[j];
        }
      }

      result.push(obj);

    }
    return JSON.stringify(result); //JSON
  }
}